/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Image_Export_Preview_FailedInputs */

const en_image_export_preview_failed = /** @type {(inputs: Image_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preview generation failed: ${i?.error}`)
};

const fr_image_export_preview_failed = /** @type {(inputs: Image_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de la generation de la previsualisation : ${i?.error}`)
};

const de_image_export_preview_failed = /** @type {(inputs: Image_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vorschau-Generierung fehlgeschlagen: ${i?.error}`)
};

const it_image_export_preview_failed = /** @type {(inputs: Image_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generazione dell'anteprima non riuscita: ${i?.error}`)
};

const ru_image_export_preview_failed = /** @type {(inputs: Image_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось создать предварительный просмотр: ${i?.error}`)
};

const es_image_export_preview_failed = /** @type {(inputs: Image_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error en la generación de la vista previa: ${i?.error}`)
};

const zh_cn2_image_export_preview_failed = /** @type {(inputs: Image_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`预览生成失败：${i?.error}`)
};

const ja_image_export_preview_failed = /** @type {(inputs: Image_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プレビュー生成に失敗しました: ${i?.error}`)
};

const hi_image_export_preview_failed = /** @type {(inputs: Image_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`पूर्वावलोकन निर्माण विफल: ${i?.error}`)
};

const pt_pt2_image_export_preview_failed = /** @type {(inputs: Image_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A geração da pré-visualização falhou: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Preview generation failed: {error}" |
*
* @param {Image_Export_Preview_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_failed = /** @type {((inputs: Image_Export_Preview_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_preview_failed(inputs)
	if (locale === "de") return de_image_export_preview_failed(inputs)
	if (locale === "it") return it_image_export_preview_failed(inputs)
	if (locale === "ru") return ru_image_export_preview_failed(inputs)
	if (locale === "es") return es_image_export_preview_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_preview_failed(inputs)
	if (locale === "ja") return ja_image_export_preview_failed(inputs)
	if (locale === "hi") return hi_image_export_preview_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_preview_failed(inputs)
	return en_image_export_preview_failed(inputs)
});